import type { AiAppCenterModule } from '../types'

export const spaceBookingModule: AiAppCenterModule = {
  key: 'space-booking',
  label: '空间预订',
  desc: '商业空间场地管理、会员端浏览选时与预订（米家空间迁移）',
  path: '/space-booking',
  homePath: '/space-booking/category',
  icon: 'ep:office-building',
  color: '#165dff'
}
